/* global bsBreakpoints */

const switchLangBloc = document.querySelector(
	'.language-switcher-language-url'
);
const langues = switchLangBloc.querySelectorAll('li');

const splitLetter = () => {
	langues.forEach((lang) => {
		const txt = lang.querySelector('a').innerText;
		lang.querySelector('a').innerText = txt.substring(0, 2);
	});
};

const checkCurrentLang = () => {
	langues.forEach((lang) => {
		const dataLang = lang.querySelector('a').getAttribute('hreflang');
		lang.querySelector('a').classList.add(dataLang + '-flag');
	});
};

const switchLang = () => {
	switchLangBloc.querySelectorAll('a').forEach((item) => {
		item.addEventListener('click', (e) => {
			if (
				document
					.querySelector('.links')
					.classList.contains('links--display')
			) {
				document
					.querySelector('.links')
					.classList.remove('links--display');
				return true;
			} else {
				e.preventDefault();
				document
					.querySelector('.links')
					.classList.add('links--display');
			}

			if (bsBreakpoints.detectBreakpoint() === 'xSmall') {
				const navReturn = document.querySelector('.responsive-return');
				navReturn.classList.toggle('responsive-return--active');
				navReturn.addEventListener('click', () => {
					switchLangBloc.classList.remove(
						'language-switcher-language-url--active'
					);
					document
						.querySelector('.links')
						.classList.remove('links--display');
					navReturn.classList.remove('responsive-return--active');
				});
				let linksH = 0;
				langues.forEach((lang, index) => {
					const h = lang.offsetHeight;
					linksH += linksH + h;
				});
				switchLangBloc.classList.toggle(
					'language-switcher-language-url--active'
				);
			}
		});
	});
};

const respSwitch = () => {
	if (bsBreakpoints.detectBreakpoint() === 'xSmall') {
		const menuResp = document.querySelector('.header__menu__responsive');
		menuResp.appendChild(switchLangBloc);
	}
};

splitLetter();
checkCurrentLang();
switchLang();
respSwitch();
